var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"alert-dialog","title":_vm.title,"ok-title":"OK","ok-only":"","no-close-on-backdrop":true},on:{"ok":_vm.handleOk}},[_c('div',{staticClass:"confirmMessage"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }